import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { extraSmall } from 'utils';

const sizes = {
  spacing_801: 24,
  spacing_1301: 32,
};

// Widths at which the list gains a column.
const columns = { two: 801, three: 1024, four: 1301 };

export const UL = styled.ul<{ $singleRow?: boolean }>`
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
  width: 100%;
  list-style: none;
  margin: ${rem(32)} 0 0 0;
  padding: 0 0 ${rem(24)} 0;
  row-gap: ${rem(56)};

  ${extraSmall(css`
    margin-top: ${rem(48)};
  `)}

  > li {
    width: 100%;
  }

  @media screen and (min-width: ${columns.two}px) {
    column-gap: ${rem(sizes.spacing_801)};

    > li {
      width: calc((100% - ${rem(sizes.spacing_801)}) / 2);
    }
  }

  @media screen and (min-width: ${columns.three}px) {
    > li {
      width: calc((100% - ${rem(sizes.spacing_801 * 2)}) / 3);
    }
  }

  @media screen and (min-width: ${columns.four}px) {
    column-gap: ${rem(sizes.spacing_1301)};
    > li {
      width: calc((100% - ${rem(sizes.spacing_1301 * 3)}) / 4);
    }
  }

  ${({ $singleRow }) =>
    $singleRow &&
    css`
      @media screen and (max-width: ${columns.two - 1}px) {
        > li:nth-child(n + 2) {
          display: none;
        }
      }

      @media screen and (min-width: ${columns.two}px) and (max-width: ${columns.three -
        1}px) {
        > li:nth-child(n + 3) {
          display: none;
        }
      }

      @media screen and (min-width: ${columns.three}px) and (max-width: ${columns.four -
        1}px) {
        > li:nth-child(n + 4) {
          display: none;
        }
      }
    `}
`;
